import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { Bus } from '@orion.ui/orion';

export type SharedPagedListOrderHeaderEmits = {
	(e: 'update:modelValue', value: OrderValue): void
	(e: 'refreshList'): void
	(e: 'selectAll'): void
};
export type SharedPagedListOrderHeaderProps = {
	hideSelection?: boolean
	listSelectedItems?: any[]
	listHasAllItemsSelected?: number | boolean
	orders: OrderOptions[]
	modelValue: OrderValue
};

type OrderValue = {
	property: string
	ascending: boolean
};

type OrderOptions = {
	key: string
	label: string
	clickable?: boolean
	class?: string
};

export default class SharedPagedListOrderHeaderSetup extends BaseSetup {

	static readonly defaultProps = {
		listSelectedItems: () => [],
		listHasAllItemsSelected: false,
	};

	private highlighterTimer?: NodeJS.Timeout;
	@Reactive private readonly state = {
		highlighter: {
			animate: false,
			show: false,
			left: 0,
			width: 0,
		},
	};

	get highlighterAnimate () { return this.state.highlighter.animate }
	get highlighterShow () { return this.state.highlighter.show }
	get highlighterLeft () { return this.state.highlighter.left }
	get highlighterWidth () { return this.state.highlighter.width }
	get allSelected () { return this.props.listHasAllItemsSelected }
	get checkboxChecked () { return this.allSelected || this.props.listSelectedItems?.length }

	get activeValue () { return this.props.modelValue }
	set activeValue (val: OrderValue) { this.emits('update:modelValue', val) }

	constructor (
		private props: SharedPagedListOrderHeaderProps,
		private emits: SharedPagedListOrderHeaderEmits,
	) {
		super();
	}

	getOrderStatus (key: string) {
		return {
			color: this.activeValue.property === key ? 'info' : 'default' as Orion.Color,
			icon: this.activeValue.property === key && this.activeValue.ascending ? 'chevron_up' : 'chevron_down',
		};
	}

	toggleOrder (order: OrderOptions) {
		if (order.clickable !== false) {
			this.activeValue = {
				ascending: this.activeValue.property === order.key ? !this.activeValue.ascending : false,
				property: order.key,
			};
			this.emits('refreshList');
		}
	}

	emitOverOrder (key: string, e: MouseEvent) {
		// Prevent highlighter remove from previous mouseout
		clearTimeout(this.highlighterTimer);

		// Define coordinates
		const { left, width } = (e.target as HTMLElement).getBoundingClientRect();
		this.state.highlighter.left = left;
		this.state.highlighter.width = width;

		setTimeout(() => {
			// Enable animation after coord for first appearance
			this.state.highlighter.animate = true;
			// Scale and opacity animation
			this.state.highlighter.show = true;
		}, 10);

		Bus.emit('pagedListOrderHeader:over', key);
	}

	emitOutOrder (key: string) {
		Bus.emit('pagedListOrderHeader:out', key);

		// Scale and opacity animation
		this.state.highlighter.show = false;

		// Reset state after css animation 300ms
		this.highlighterTimer = setTimeout(() => {
			this.state.highlighter.animate = false;
			this.state.highlighter.left = 0;
			this.state.highlighter.width = 0;
		}, 350);
	}

}
